/**
 =========================================================
 * Material Dashboard 2 React - v2.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2021 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";


import PageLayout from "examples/LayoutContainers/PageLayout";

import Footer from "examples/Footer";
import Formulario from "./components/Fomulario"
import {useEffect, useState, useContext} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";

import CandidatoContext from "../../context/candidato/candidatoContext";
import axios from '../../config/axios';
import MDButton from "../../components/MDButton";


function REC_RES_LINK(props) {
    const [imagems, setImagens] = useState([{nome: '', imagem: ''}])
    const [candidato, setCandidato] = useState([{nome: '', cargo: ''}])
    const [token, setToken] = useState('')
    const {candidatoState, candidatoDispatch} = useContext(CandidatoContext);
    const navigate = useNavigate()

    useEffect(() => {
        //Verifica refresh
        if (candidatoState.concurso.edital.length === 0) {
            candidatoDispatch({type: "REFRESH"})
        }
    }, [])

    useEffect(() => {
        (async () => {
            console.log('candidatoState', candidatoState);
            let response = await axios.get('/candidato/resultado_recurso', {
                params: {
                    token: candidatoState.token
                }
            });

            //redireciona para o link
            window.location.href= response.data.justificativa;
            setCandidato(response.data);
        })()
    }, [candidatoState])

    const loading = () => {
        return imagems[0].nome.length === 0 && (<CircularProgress/>);
    }

    const mostra_justificativa = () => {
        if (candidato.justificativa && candidato.justificativa.length > 0)
            return "JUSTIFICATIVA"
        else
            return ""
    }
    return (<PageLayout>
        <MDBox pt={10} width="80%" m="auto">
            <Card>
                <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
                    <Grid container spacing={3} justifyContent='center'>
                        <Grid item xs={12} md={4} xl={2} textAlign="center">
                            <img style={{width: '100%'}}
                                 src={candidatoState.concurso.logo}/>
                        </Grid>
                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="button" fontWeight="bold">
                                {candidatoState.concurso.edital}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="h4" fontWeight="bold" style={{color: "#184282"}} color="text">

                            </MDTypography>
                        </Grid>




                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="h5" fontWeight="bold" color="text">
                                <MDButton  size={'large'} color={"secondary"} onClick={() => {
                                      window.location.href= candidato.justificativa;
                                    // console.log(candidato.justificativa)
                                    }}>Clique aqui caso não seja redirecionado
                                    automaticamente</MDButton>
                            </MDTypography>

                        </Grid>




                    </Grid>
                </MDBox>
                {/*<Formulario inscricao={inscricao}/>*/}
            </Card>
            <Footer/>
        </MDBox>
    </PageLayout>);
}

export default REC_RES_LINK;
